import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./styles/Footer.css";

const Footer = () => {
  const location = useLocation();

  // Не фиксируем футер на главной и обуви
  const isNoFixPage = location.pathname === "/" || location.pathname.startsWith("/shoes");

  useEffect(() => {
    if (isNoFixPage) {
      return;
    }
    // Проверяем, меньше ли контента, чем высота окна
    const checkFixed = () => {
      const body = document.body;
      const html = document.documentElement;
      const contentHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
      // +2 px запас
    };
    checkFixed();
    window.addEventListener('resize', checkFixed);
    return () => window.removeEventListener('resize', checkFixed);
  }, [location.pathname, isNoFixPage]);

  return (
    <footer className="footer">
      <div className="footer-center-text">ИП Ситдикова, г. Пермь</div>
      <div className="footer-links-row">
        <Link to="/privacy-policy">Политика конфиденциальности</Link>
        <Link to="/consent-personal-data">Согласие на обработку персональных данных</Link>
        <Link to="/user-agreement">Пользовательское соглашение, публичная оферта</Link>
      </div>
    </footer>
  );
};

export default Footer; 